import React from 'react'

interface HtmlSlideProps {
  /** Pre-rendered HTML string (already processed through templateEngine) */
  html: string
}

/**
 * Renders an HTML presentation slide.
 *
 * The wrapper div is completely transparent so the inner template controls
 * all dimensions and styling.
 */
const HtmlSlide: React.FC<HtmlSlideProps> = ({ html }) => {
  return <div dangerouslySetInnerHTML={{ __html: html }} />
}

export default HtmlSlide
